import { Action } from '@ngrx/store';
import { ActionTypes } from './ngrx-store.actions';

export const initialState: any = {};

export function RootReducer(state = initialState, action: Action): any {
    const actionWithPayload = action as Action & { payload?: any };

    if (action.type === ActionTypes.save.toString()) {
        return Object.assign(state, actionWithPayload.payload);
    }
    if (action.type === ActionTypes.delete.toString()) {
        delete state[actionWithPayload.payload];
        return state;
    }
    return state;
}
